<template>
  <div>
    <!-- style="width: 100%; height: 240px" -->
    <ag-grid-vue v-bind:style="{ height: heightInside }" style="width: 100%; "
      class="ag-theme-balham center-box elevation-2 taskValidationGrid" :columnDefs="columnDefs" :rowData="rowData"
      :gridOptions="gridOptions" :rowSelection="rowSelection" :enableCellChangeFlash="true"
      @selection-changed="onSelectionChanged" @grid-ready="onGridReady" pagination=true
      :overlayNoRowsTemplate="overlayNoRowsTemplate"></ag-grid-vue>
  </div>
</template>

<script>
import { appSettings } from "@/common/app.settings.js";
import { AgGridVue } from "ag-grid-vue3";
import { dateService } from "@/services/date.service.js";
import { CONSTANTS } from "@/common/constants.js";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";

import { STORE_CONSTANTS } from "@/common/store.constants.js";

export default {
  name: "TrackAgregateTable",
  props: {
    tracksData: Array,
    view: String,
    heightInside: String,
    isExporting: Boolean,
    study: String
  },
  components: {
    AgGridVue
  },
  data: () => ({
    STORE_CONSTANTS,
    columnDefs: null,
    rowData: null,
    selectedRowData: null,
    loading: false,
    rowSelection: "single",
    gridApi: null,
    results: null,
    totalItems: null,
    overlayNoRowsTemplate: null,
    staffFullName: ''
  }),
  computed: {
    dataGrid: function () {
      return this.tracksData
    }
  },
  // Watch the following fields, whenever the value changes, these functions will run with the fields old and new values
  watch: {    
    dataGrid: function (newValue, oldValue) {
      if (newValue !== oldValue) {
        console.log('newValue: ', newValue)
        this.gridApi.setRowData(newValue)
        if (newValue.length > 0) {
          this.getTracksForDay(newValue[0])
        }
      }
    },
    view: function (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.loadProperColumnDefs(newValue);
      }
    },
    isExporting: function (newValue, oldValue) {
      if (newValue === true) {
        const data = this.gridApi.getDataAsCsv();
        this.$emit('rowsExported', { data });
      }
    },
    study: function (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.study = newValue;
        this.loadProperColumnDefs(this.view);
      }
    }
  },
  /**
  * Component lifecycle created handler
  */
  created() {
    const me = this;
    me.overlayNoRowsTemplate = '<span style="padding: 10px; border: 2px solid #2b7588; background: #e0e0e0; font-size: 14px">There is no data for this query.</span>';
  },
  /**
  * Component lifecycle beforeMount handler
  */
  beforeMount() {
    this.type = "listView";
    this.gridOptions = {};
    this.gridOptionsCases = {};
    this.rowSelection = "single";
  },
  /**
  * Component lifecycle mounted handler
  */
  mounted() {
    this.loadProperColumnDefs(this.view);
    this.gridApi = this.gridOptions.api;
    this.gridColumnApi = this.gridOptions.columnApi;
    window.addEventListener('resize', this.onResize);

    this.rowdata = this.dataGrid
    this.gridApi.setRowData(this.tracksData);
    this.selectedRowData = this.gridApi.getSelectedRows();
    console.log('this.selectedRowData: ', this.selectedRowData)
    if (this.tracksData[0]) {
      this.getTracksForDay(this.tracksData[0])
    }
  },
  /**
  * Component lifecycle updated handler
  */
  updated() {
    this.onResize()
  },
  // /**
  // * Component lifecycle beforeDestroy handler
  // */
  // beforeDestroy() {
  //   this.gridApi.destroy();
  //   this.gridColumnApi.destroy();

  //   window.removeEventListener('resize', this.onResize);
  // },
  /**
  * Component lifecycle beforeUnmount handler
  */  
  beforeUnmount() {
    this.gridApi.destroy();

    window.removeEventListener('resize', this.onResize);
  },
  methods: {
    /**
     * Converts meters to miles
     */
    getMiles(meters) {
      let miles
      if (meters || meters === 0) {
        miles = (meters * 0.000621371192).toFixed(2) + 'miles'
      }
      return miles
    },
    /**
     * Formats the specified date based on the geo point
     * @param {*} date 
     * @param {*} point 
     */
    getFormattedDate(date, point) {
      if (date && date.length) {
        return dateService.formatDateTimeLocal(date, point);
      }
      return 'N/A';
    },
    /**
     * Helper to handle ag grid row selection change event
     */
    onSelectionChanged() {
      this.selectedRowData = this.gridApi.getSelectedRows();
      this.getTracksForDay(this.selectedRowData[0]);
      this.$emit('updateTrackSummaryCriteria', this.selectedRowData[0]);
    },
    /**
     * Helper used to make call to API to fetch tracks for a day
     * @param {*} myCriteria 
     */
    getTracksForDay(myCriteria) {
      console.log('getTracksForDay in Track table')
      console.log('getTracksForDay myCriteria: ', myCriteria)
      // timeEnd is the start of the say right now
      const me = this;

      // We only need the YYYY-MM-DD from the date, so we take everything before the 'T'
      const rangeStart = myCriteria.trackTimeFirstISO.split("T")[0] || "";
      const rangeEnd = myCriteria.trackTimeLastISO.split("T")[0] || "";

      const staff = me.$store.getters['study/getSelectedStudyStaffMap'][myCriteria.staffIdStaff];
      if(staff) {
        me.staffFullName = staff.nameFirst + " " + staff.nameLast;
      }

      let criteria = {
        study: me.study,
        staffId: myCriteria.staffIdStaff,
        dateStart: rangeStart,
        dateEnd: rangeEnd
      };
      console.log('getTracksForDay criteria: ', criteria)

      me.$store.commit(
        me.STORE_CONSTANTS.VALIDATION.MUTATIONS.WITH_NAMESPACE.SET_IS_LOADING,
        true
      );

      me.$store
        .dispatch(
          me.STORE_CONSTANTS.TRACKS.ACTIONS.WITH_NAMESPACE.GET_TRACKS_AND_CLUSTERS_FOR_DAY,
          criteria
        )
        .then((results) => {
          if (!results.tracks) {
            me.$store.commit(
              me.STORE_CONSTANTS.VALIDATION.MUTATIONS.WITH_NAMESPACE
                .SET_IS_LOADING,
              false
            );
          }
        })
        .catch((err) => {
          console.error(err);
          me.$store.commit(
            me.STORE_CONSTANTS.VALIDATION.MUTATIONS.WITH_NAMESPACE
              .SET_IS_LOADING,
            false
          );
        });
    },
    /**
     * Helper method to handle ag grid row double clicked event.
     * @param {*} evt 
     */
    onRowDoubleClicked(evt) {
      this.selectedRowData = evt.data;
      if (this.selectedRowData) {
        this.rightRowData = this.selectedRowData.caseList;
        this.assignStaffId = this.selectedRowData.idStaff;
      }
    },
    /**
     * Helper to load the ag grid column defs based on view
     * @param {*} view 
     */
    loadProperColumnDefs(view) {
      switch (view) {
        case CONSTANTS.DEFAULTS.VIEW:
          this.loadDataGridConfiguration("tasksByStatus");
          break;
        case CONSTANTS.DEFAULTS.VIEWSTAFF:
          this.loadDataGridConfiguration("tasksByStaff");
          break;
        case CONSTANTS.DEFAULTS.VIEWSPID:
          this.loadDataGridConfiguration("tasksBySPID");
          break;
        default:
          break;
      }
    },
    /**
     * Helper method to load ag grid column definitions based on the view. NOTE: The available column defintions are 
     * part of the project configuration.
     * @param {*} view 
     */
    loadDataGridConfiguration(view) {
      const me = this
      // TODO - look into whats up with the store
      // var myUiComponents = this.$store.getters["uiTableConfigurations"];
      var myUiComponents = JSON.parse(localStorage.getItem('myUiComponents'))
      // setting the UI components for Path as default
      var mySingleUiComponent;
      for (let piece of myUiComponents) {
        if (piece.idStudyCode === "PATH" && piece.uiComponents) {
          mySingleUiComponent = piece.uiComponents
        }
      }
      // grab the UI components for the matching study
      for (let piece of myUiComponents) {
        if (piece.idStudyCode === me.study && piece.uiComponents) {
          mySingleUiComponent = piece.uiComponents
        }
      }

      // do not proceed if mySingleUiComponent is null
      if (!mySingleUiComponent) {
        return;
      }

      // grab the UI configuration based of the view to be used for the dataGrid
      let dataGridConfig;
      for (let componentConfig of mySingleUiComponent) {
        if (componentConfig.componentName === 'tracksByStaff') {
          dataGridConfig = componentConfig
        }
      }
      // set the columns, with constant and custom info
      var createdColumns = []
      for (let columnObj of dataGridConfig.columnDefs) {
        // constant info + hide and order custom attributes
        let oneColumn = {
          resizable: true,
          sortable: true,
          filter: true,
          cellStyle: { display: 'flex' },
          hide: columnObj.hide,
          sortingOrder: columnObj.order,
          field: columnObj.field,
          filterParams: { newRowsAction: 'keep' },
          headerName: columnObj.headerName
        }
        if (columnObj.field === "timeLastTrack") {
          oneColumn.cellRenderer = (params) => {
            var daF = dateService.formatDateTime(params.data.timeLastTrack);
            return daF;
          }
        }
        // Overriding if cellRender exist
        if (columnObj.cellRenderer !== '') {
          var cellRenderName = columnObj.cellRenderer
          // custom for cluster duration (milisecond to hours minutes )
          if (cellRenderName === "crTaskCluster_Duration") {
            oneColumn.cellRenderer = (params) => {
              if (params.data.clusterDuration) {
                var stringData = params.data.clusterDuration + '';
                return dateService.formatDurationMilliToHourSec(stringData);
              }
            }
          }
          // custom for cluster distance ( meters to miles)
          if (cellRenderName === "crTaskCluster_Distance") {
            oneColumn.cellRenderer = (params) => {
              return me.getMiles(params.data.clusterDistance)
            }
          }
        }
        // Overriding if valueGetter exist
        if (columnObj.valueGetter !== '') {
          var valueGetterName = columnObj.valueGetter
          if (valueGetterName === "vgTaskStaffName") {
            oneColumn.field = "nameFirst";
            oneColumn.valueGetter = (params) => {
              // Just return an empty string if the values are empty
              if (!params.data.nameFirst && !params.data.nameLast) {
                return me.staffFullName;
              }

              return `${params.data.nameFirst} ${params.data.nameLast}`;
            }
            oneColumn.cellRenderer = (params) => {
              // Just return an empty string if the values are empty
              if (!params.data.nameFirst && !params.data.nameLast) {
                return me.staffFullName;
              }

              return (
                params.data.nameFirst + " " + params.data.nameLast
              )
            }
          }

          // Displays whether or not the task has an alternate location. The field is not always
          // present on the task object, so we need to check if it exists before returning a value.
          if(valueGetterName === "vgTaskAltLocation") {
						oneColumn.field = "alternateLocation";
						oneColumn.valueGetter = (params) => {
							return (params.data.alternateLocation) ? params.data.alternateLocation : false;
						}
					}
        }
        // for some reason manager and supervisor aren't supplied with a field data
        if (columnObj.field === "" && columnObj.headerName === "Manager") {
          oneColumn.cellRenderer = (params) => {
            return (
              params.data.fieldMgrName
            )
          }
        }
        if (columnObj.field === "" && columnObj.headerName === "Supervisor") {
          oneColumn.cellRenderer = (params) => {
            return (
              params.data.fieldSupName
            )
          }
        }
        if (columnObj.field === "dateStart") {
          oneColumn.valueGetter = (params) => {
            var daF = dateService.formatDateBlank(params.data.dateStart);
            return (
              this.getFormattedDate(daF, params.data.point)
            )
          }
          oneColumn.cellRenderer = (params) => {
            var daF = dateService.formatDateBlank(params.data.dateStart);
            return (
              this.getFormattedDate(daF, params.data.point)
            )
          }
        }

        if (columnObj.field === "idStaff" || columnObj.field === "staffIdStaff") {
          oneColumn.cellRenderer = (params) => {
            return (
              params.data.staffIdStaff
            )
          }
        }

        if (columnObj.field === "timeStartISO") {
          oneColumn.cellRenderer = (params) => {
            return (
              dateService.formatDateTimeTracks(params.data.trackTimeFirst)
            )
          }
        }

        if (columnObj.field === "gpsSource" || columnObj.field === "trackGpsSource") {
          oneColumn.cellRenderer = (params) => {
            return (
              params.data.trackGpsSource
            )
          }
        }

        if (columnObj.field === "timeStart") {
          oneColumn.valueGetter = (params) => {
            return (
              dateService.getDateTime(params.data.timeStart)
            )
          }
          oneColumn.cellRenderer = (params) => {
            return (
              dateService.getDateTime(params.data.timeStart)
            )
          }
        }

        if (columnObj.field === "dateEnd") {
          oneColumn.valueGetter = (params) => {
            return dateService.formatDateTimeBottomTable(params.data.dateEnd, params.data.point);
          }
          oneColumn.cellRenderer = (params) => {
            return dateService.formatDateTimeBottomTable(params.data.dateEnd, params.data.point);
          }
        }
        // custom for header
        // console.log('this.dataGrid', this.dataGrid)
        // var dataGridTotal = this.dataGrid.length
        // var getTasksHeaderPlusRowCount = function () {
        // 	return "Tasks (" + dataGridTotal + ")"
        // }
        // if (columnObj.headerName === "Task Completed") {
        // 	oneColumn.headerValueGetter = getTasksHeaderPlusRowCount
        // } else {
        // 	oneColumn.headerName = columnObj.headerName;
        // }
        // adding a column to columns list
        createdColumns.push(oneColumn)
      }
      console.log('createdColumns: ', createdColumns)
      this.columnDefs = createdColumns;
    },
    /**
     * Load column defs for task
     */    
    loadTasksForStatusColumnDefs() {
      var statusBasisPopover =
        "<div ng-class=\"{ 'sortable': sortable }\">" +
        '<div class="ui-grid-vertical-bar">&nbsp;</div>' +
        '<div class="ui-grid-cell-contents" col-index="renderIndex"><span class="">{{col.colDef.displayName}}</span>' +
        "<span ui-grid-visible=\"col.sort.direction\" ng-class=\"{ 'ui-grid-icon-up-dir': col.sort.direction == asc, 'ui-grid-icon-down-dir': col.sort.direction == desc, 'ui-grid-icon-blank': !col.sort.direction }\">" +
        "&nbsp;" +
        "</span>" +
        "</div>" +
        '<div class="ui-grid-column-menu-button" ng-if="grid.options.enableColumnMenus && !col.isRowHeader  && col.colDef.enableColumnMenu !== false" class="ui-grid-column-menu-button" ng-click="toggleMenu($event)">' +
        '<i class="ui-grid-icon-angle-down">&nbsp;</i>' +
        "</div>" +
        '<div class="ui-grid-column-menu-button ui-grid-cell-contents" show-help tmpl="statusBasis.help.html" popover-append-to-body="true" popover-placement="top"></div>' +
        "</div>" +
        "</div>";

      var geoPrecisionPopover =
        "<div ng-class=\"{ 'sortable': sortable }\">" +
        '<div class="ui-grid-vertical-bar">&nbsp;</div>' +
        '<div class="ui-grid-cell-contents" col-index="renderIndex"><span class="">{{col.colDef.displayName}}</span>' +
        "<span ui-grid-visible=\"col.sort.direction\" ng-class=\"{ 'ui-grid-icon-up-dir': col.sort.direction == asc, 'ui-grid-icon-down-dir': col.sort.direction == desc, 'ui-grid-icon-blank': !col.sort.direction }\">" +
        "&nbsp;" +
        "</span>" +
        "</div>" +
        '<div class="ui-grid-column-menu-button" ng-if="grid.options.enableColumnMenus && !col.isRowHeader  && col.colDef.enableColumnMenu !== false" class="ui-grid-column-menu-button" ng-click="toggleMenu($event)">' +
        '<i class="ui-grid-icon-angle-down">&nbsp;</i>' +
        "</div>" +
        '<div class="ui-grid-column-menu-button ui-grid-cell-contents" show-help tmpl="geoPrecision.help.html" popover-append-to-body="true" popover-placement="top"></div>' +
        "</div>" +
        "</div>";
      var dataGridTotal = this.dataGrid.length
      var getTasksHeaderPlusRowCount = function () {
        return "Tasks (" + dataGridTotal + ")"
      }
      this.columnDefs = [
        {
          field: "properties.TaskUUID",
          headerName: "Task ID",
          width: 120,
          resizable: true,
          sortable: true,
          filter: true,
          hide: !false,
          cellStyle: { display: 'flex' }
        },
        {
          field: "properties.DateCOMPLETED",
          // headerValueGetter: getTasksHeaderPlusRowCount,
          headerName: "Date Completed",
          width: 150,
          resizable: true,
          sortable: true,
          filter: true,
          cellStyle: { display: 'flex' }
        },
        {
          field: "properties.DateINTERIM",
          headerName: "Task Interim",
          width: 120,
          resizable: true,
          sortable: true,
          filter: true,
          hide: !appSettings[this.study].searchResultsDisplay.byStatus
            .DateINTERIM,
          cellStyle: { display: 'flex' }
        },
        {
          field: "properties.DateASSIGNED",
          headerName: "Task Assigned",
          width: 120,
          resizable: true,
          sortable: true,
          filter: true,
          hide: !appSettings[this.study].searchResultsDisplay.byStatus
            .DateASSIGNED,
          cellStyle: { display: 'flex' }
        },
        {
          field: "properties.DateCREATED",
          headerName: "Task Created",
          width: 120,
          resizable: true,
          sortable: true,
          filter: true,
          hide: !appSettings[this.study].searchResultsDisplay.byStatus
            .DateCREATED,
          cellStyle: { display: 'flex' }
        },
        {
          field: "properties.StaffId",
          headerName: "Staff ID",
          width: 85,
          resizable: true,
          sortable: true,
          filter: true,
          cellStyle: { display: 'flex' }
        },
        {
          field: "properties.StaffName",
          headerName: "Staff Name",
          width: 105,
          resizable: true,
          sortable: true,
          filter: true,
          cellStyle: { display: 'flex' }
        },
        {
          field: "properties.Status",
          headerName: "Status",
          width: 80,
          resizable: true,
          sortable: true,
          filter: true,
          cellStyle: { display: 'flex' }
        },
        {
          field: "properties.DUID",
          headerName:
            !appSettings[this.study].searchResultsDisplay.byStatus ||
              !appSettings[this.study].searchResultsDisplay.byStatus
                .columnLabels ||
              !appSettings[this.study].searchResultsDisplay.byStatus.columnLabels
                .duidLabel
              ? "DUID"
              : appSettings[this.study].searchResultsDisplay.byStatus
                .columnLabels.duidLabel,
          width: 120,
          resizable: true,
          sortable: true,
          filter: true,
          // hide: false,
          hide: !appSettings[this.study].searchResultsDisplay.byStatus.showDUID,
          cellStyle: { display: 'flex' }
        },
        {
          field: "properties.SPID",
          headerName: "SPID",
          width: 80,
          resizable: true,
          sortable: true,
          cellRenderer: (params) => {
            return (
              params.data.properties.SPID ||
              appSettings[this.study].searchResultsDisplay.byStatus.columnValues
                .spidNoDataValue ||
              "No Data"
            );
          },
          filter: true,
          hide: !(
            !appSettings[this.study].searchResultsDisplay ||
            !appSettings[this.study].searchResultsDisplay.byStatus ||
            appSettings[this.study].searchResultsDisplay.byStatus.showSPID
          ),
          cellStyle: { display: 'flex' }
        },
        {
          field: "properties.Region",
          headerName: "Region",
          width: 80,
          resizable: true,
          sortable: true,
          filter: true,
          hide: !(
            !appSettings[this.study].searchResultsDisplay ||
            !appSettings[this.study].searchResultsDisplay.byStatus ||
            !appSettings[this.study].searchResultsDisplay.byStatus.showRegion ||
            appSettings[this.study].searchResultsDisplay.byStatus.showRegion
          ),
          cellRenderer: (params) => {
            return (
              params.data.properties.Region ||
              "No Data"
            );
          },
          cellStyle: { display: 'flex' }
        },
        {
          field: "properties.PSU",
          headerName:
            !appSettings[this.study].searchResultsDisplay.byStatus ||
              !appSettings[this.study].searchResultsDisplay.byStatus
                .columnLabels ||
              !appSettings[this.study].searchResultsDisplay.byStatus.columnLabels
                .psuLabel
              ? "PSU"
              : appSettings[this.study].searchResultsDisplay.byStatus
                .columnLabels.psuLabel,
          width: 70,
          resizable: true,
          sortable: true,
          filter: true,
          cellRenderer: (params) => {
            return (
              params.data.properties.PSU ||
              "No Data"
            );
          },
          cellStyle: { display: 'flex' }
        },
        {
          field: "properties.Segment",
          headerName: "Segment",
          width: 90,
          resizable: true,
          sortable: true,
          filter: true,
          cellRenderer: (params) => {
            return (
              params.data.properties.Segment ||
              "No Data"
            );
          },
          cellStyle: { display: 'flex' }
        },
        {
          field: "properties.TaskLabel",
          headerName: "Task Label",
          width: 100,
          resizable: true,
          sortable: true,
          filter: true,
          cellStyle: { display: 'flex' }
        },
        {
          field: "properties.DispositionCode",
          headerName: "Task Status Code",
          width: 100,
          resizable: true,
          sortable: true,
          filter: true,
          hide: !false,
          cellStyle: { display: 'flex' }
        },
        {
          field: "properties.DispositionLabel",
          headerName: "Task Status",
          width: 100,
          resizable: true,
          sortable: true,
          filter: true,
          cellStyle: { display: 'flex' }
        },
        {
          field: "properties.StatusBasis",
          headerName: "Status Basis",
          headerCellTemplate: statusBasisPopover,
          width: 120,
          resizable: true,
          sortable: true,
          filter: true,
          cellStyle: { display: 'flex' }
        },
        {
          field: "properties.GeoMatchType",
          headerName: "Geo Precision",
          headerCellTemplate: geoPrecisionPopover,
          width: 120,
          cellRenderer: (params) => {
            return params.data.properties.GeoMatchType || "No Data";
          },
          resizable: true,
          sortable: true,
          filter: true,
          cellStyle: { display: 'flex' }
        },
        {
          field: "properties.ClusterDuration",
          headerName: "Cluster Duration",
          width: 120,
          cellRenderer: (params) => {
            return dateService.formatDuration(
              params.data.properties.ClusterDuration
            );
          },
          resizable: true,
          sortable: true,
          filter: true,
          cellStyle: { display: 'flex' }
        },
        {
          field: "properties.dateEnd",
          headerName: "Task Time",
          width: 120,
          resizable: true,
          sortable: true,
          filter: true,
          hide: !false,
          cellStyle: { display: 'flex' }
        },
        {
          field: "properties.ClusterDistance",
          headerName: "Cluster Distance",
          width: 80,
          resizable: true,
          sortable: true,
          // params.data.properties.ClusterDistanceUnit is meters, converting meters to miles
          cellRenderer: (params) => {
            return (params.data.properties.ClusterDistance ? (params.data.properties.ClusterDistance + params.data.properties.ClusterDistanceUnit) : "No Data");
          },
          cellStyle: { display: 'flex' }
        }
      ];
    },
    /**
     * Function to load results into grid
     */
    loadStaffDailySummaryColumnDefs() {
      // grid column headers
      this.columnDefs = [
        {
          field: "properties.DateStart",
          headerName: "Day Start",
          width: 120,
          resizable: true,
          sortable: true,
          filter: true,
          hide: false,
          cellStyle: { display: 'flex' }
        },
        {
          field: "properties.DateEnd",
          headerName: "Day End",
          width: 120,
          resizable: true,
          sortable: true,
          filter: true,
          hide: false,
          cellStyle: { display: 'flex' }
        },
        {
          field: "properties.StaffId",
          headerName: "Staff ID",
          width: 120,
          resizable: true,
          sortable: true,
          filter: true,
          cellStyle: { display: 'flex' }
        },
        {
          field: "properties.StaffName",
          headerName: "Staff Name",
          width: 120,
          resizable: true,
          sortable: true,
          filter: true,
          cellStyle: { display: 'flex' }
        },
        {
          field: "properties.Manager",
          headerName: "Manager",
          width: 120,
          resizable: true,
          sortable: true,
          filter: true,
          cellStyle: { display: 'flex' }
        },
        {
          field: "properties.Supervisor",
          headerName: "Supervisor",
          width: 120,
          resizable: true,
          sortable: true,
          filter: true,
          cellStyle: { display: 'flex' }
        },
        {
          field: "properties.properties.Area",
          headerName: "Area",
          cellRenderer: (params) => {
            return params.data.properties.Area || "No Data";
          },
          width: 120,
          resizable: true,
          sortable: true,
          filter: true,
          cellStyle: { display: 'flex' }
        },
        {
          field: "properties.Region",
          headerName: "Region",
          width: 120,
          resizable: true,
          sortable: true,
          filter: true,
          hide: !(
            appSettings[this.study].searchResultsDisplay === undefined ||
            appSettings[this.study].searchResultsDisplay.byStaff ===
            undefined ||
            appSettings[this.study].searchResultsDisplay.byStaff.showRegion ===
            undefined ||
            appSettings[this.study].searchResultsDisplay.byStaff.showRegion
          ),
          cellStyle: { display: 'flex' }
        },
        {
          field: "properties.Segment",
          headerName: "Segment",
          width: 120,
          resizable: true,
          sortable: true,
          filter: true,
          cellStyle: { display: 'flex' }
        },
        {
          field: "properties.PSU",
          headerName:
            appSettings[this.study].searchResultsDisplay.byStaff ===
              undefined ||
              appSettings[this.study].searchResultsDisplay.byStaff
                .columnLabels === undefined ||
              appSettings[this.study].searchResultsDisplay.byStaff.columnLabels
                .psuLabel === undefined
              ? "PSU"
              : appSettings[this.study].searchResultsDisplay.byStaff
                .columnLabels.psuLabel,
          width: 120,
          resizable: true,
          sortable: true,
          filter: true,
          cellStyle: { display: 'flex' }
        },
      ];
    },
    /**
     * Handles the resize event
     * @param {*} event 
     */
    onResize(event) {
      this.gridApi.sizeColumnsToFit();
    },
    /**
     * Handles on grid ready
     * @param {*} params 
     */
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
      params.api.sizeColumnsToFit();
    },
  },
};
</script>

<style scoped>
.ag-header-cell-text {
  color: #2b7588;
}
</style>
